export function formatUptime(totalUptime) {
    if (totalUptime < 60) {
      return `${totalUptime} sec`;
    } else if (totalUptime < 3600) {
      return `${(totalUptime / 60).toFixed(2)} min`;
    } else {
      return `${(totalUptime / 3600).toFixed(2)} hour`;
    }
}
